'use client'
import Image from 'next/image'
import Link from 'next/link'
import { IconArrowR, IconPin } from '@/icons'
import Reveal from '@/components/Reveal'
import { PRODUCTION_SITES } from '@/lib/production'

export default function Production() {
  return (
    <section id="production" className="sec-pad">
      <div className="container">
        <Reveal><div className="sec-head">
          <h2>Производственные площадки</h2>
          <Link className="more" href="/production">
            Подробнее о производстве <IconArrowR width="16" height="16" />
          </Link>
        </div></Reveal>
        <div className="sites-grid">
          {PRODUCTION_SITES.map((s, i) => (
            <Reveal key={s.id} delay={i * 130}>
            <Link className="site-card" href={s.href}>
              <div className="site-img">
                <Image src={s.image} alt={s.imageAlt} fill sizes="(max-width: 860px) 100vw, 50vw" style={{ objectFit: 'cover' }} />
              </div>
              <div className="site-body">
                <h3>{s.shortTitle}</h3>
                <div className="site-loc"><IconPin width="14" height="14" /> ({s.loc})</div>
                <span className="site-type">{s.type}</span>
                <ul>{s.points.map(p => <li key={p}>{p}</li>)}</ul>
              </div>
            </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
